import { useEffect, useState } from "react";
import Card from "components/card";
import fetchData from "Hooks/useAPI";
import useAuth from "Hooks/useAuth";
import InputField from "components/fields/InputField";
import { message, Descriptions, QRCode , Modal } from 'antd';
import { useNavigate } from "react-router-dom";
import ad_logo from './ad_logo.jpeg'

const URL = "https://adandyou.host/users_app/api/index.php/users";

const MyAccountView = () => {
    const navigate = useNavigate()
    const [messageApi, contextHolder] = message.useMessage();
    const { logout } = useAuth()
    const [user, setUser] = useState({})
    const [items, setItems] = useState({ activate:false})
    const btnClass = `linear mt-2 w-full rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200`;
    const btnClasdel = `mt-2 w-full rounded-xl bg-red-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-red-600 active:bg-red-700 dark:bg-red-400 dark:text-white dark:hover:bg-red-300 dark:active:bg-red-200`;
    useEffect(() => {
        fetchData(URL, 'GET', null, {}, logout)
            .then(response => {
                setUser(response.data)
            })
            .catch((err) => {
                console.log(err)
                messageApi.open({
                    type: 'error',
                    content: "Error al obtener datos de usuario.",
                });
                logout()
                navigate('/')
            })

    }, []);

    const handleSubmit = async () => {
        try {
            await fetchData("https://adandyou.host/users_app/api/index.php/usersEdit", 'PUT', user, {}, logout)
            messageApi.open({
                type: 'success',
                content: "Guardado exitosamente",
              });
        } catch (error) {
            messageApi.open({
                type: 'error',
                content: "Error al guardar info intente de nuevo.",
              });
        }
    }
    const cancelconfirmed = async () => {
        try {
            await fetchData("https://adandyou.host/users_app/api/index.php/deleteAccount", 'DELETE', user, {}, logout)
            message.success('Cuenta eliminada con éxito');
              logout()
            navigate('/')
        } catch (error) {
            messageApi.open({
                type: 'error',
                content: "Error al eliminar usuario.",
              });
        }
    }
    const handleSubmitCancel = async () => {
        Modal.confirm({
            title: '¿Estás seguro de que quieres eliminar tu cuenta?',
            content: 'Esta acción no se puede deshacer.',
            onOk() {
                
                cancelconfirmed();
              
            },
            onCancel() {

              message.info('Acción cancelada');
   
            }
          });
       
    }
    
    return (
        <Card extra={"w-full h-full sm:overflow-auto px-6"}>
            <header className="relative flex items-center justify-between pt-4">
                <div className="text-xl font-bold text-navy-700 dark:text-white">
                    Hola, {user.name}
                </div>

            </header>
            
            <div style={{
                cursor:'pointer'
            }} onDoubleClick={()=>{
                setItems({
                    ...items,
                    activate:!items.activate
                })
            }} className="mt-8 overflow-x-scroll xl:overflow-x-hidden">
                {contextHolder}
                <Descriptions title="Mis Datos (Doble click para editar)" bordered column={{ xxl: 2, xl: 2, lg: 1, md: 1, sm: 1, xs: 1 }}>
                    <Descriptions.Item label="Nombre">{items.activate ?<InputField
                        variant="admin"
                        extra="mb-3"
                        type="text"
                        onChange={e => setUser({
                            ...user,
                            name: e.target.value
                        })}
                        value={user.name}
                    />  : user.name}</Descriptions.Item>
                    <Descriptions.Item label="Email">{items.activate ? <InputField
                        variant="admin"
                        extra="mb-3"
                        type="text"
                        onChange={e => setUser({
                            ...user,
                            email: e.target.value
                        })}
                        value={user.email}
                    /> : user.email}{ }</Descriptions.Item>
                    <Descriptions.Item label="Telefono">{items.activate ?<InputField
                        variant="admin"
                        extra="mb-3"
                        type="text"
                        onChange={e => setUser({
                            ...user,
                            telephone: e.target.value
                        })}
                        value={user.telephone}
                    /> : user.telephone}</Descriptions.Item>
                    <Descriptions.Item label="ID">{user.id}</Descriptions.Item>
                    <Descriptions.Item label="TAG">
                        <QRCode value={user.id || '-'} />
                    </Descriptions.Item>
                    <Descriptions.Item label="">
                        <h2 style={{
                            fontWeight:'bold',
                            marginBottom:16
                        }}>Desarrollado por:</h2>
                        <img style={{
                            maxWidth:'30%',
                            marginLeft:'10%'
                        }} src={ad_logo} alt="adandyou"/>
                    </Descriptions.Item>
                </Descriptions>
                
            </div>
            
            {
                items.activate ? <button onClick={handleSubmit} className={btnClass}>
                {'Guardar'}
            </button> : null
            }
            <button onClick={handleSubmitCancel} className={btnClasdel}>
                {'⚠️ Eliminar cuenta ⚠️'}
            </button>
        </Card>
    )

}

export default MyAccountView